<template>
  <div
    class="platform-mobile-top-bar"
    :style="{ backgroundColor: primaryColor }"
    data-qa="platform-mobile-top-bar"
  >
    <button
      class="platform-mobile-top-bar__profile"
      data-qa="profile-button"
      @click="$emit('profile-click')"
    >
      <VcAvatar
        :imagePath="profileDetails.imagePath"
        :colorId="profileDetails.colorId"
        :name="profileDetails.displayName"
        size="sm"
      />
    </button>

    <div class="platform-mobile-top-bar__actions">
      <button
        v-if="showAiChat"
        class="platform-mobile-top-bar__action-btn"
        data-qa="ai-chat-button"
        @click="$emit('ai-chat-click')"
      >
        <AiChatStarIcon class="platform-mobile-top-bar__ai-icon" />
      </button>

      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="search-button"
        @click="$emit('search-click')"
      >
        <VcIcon size="16" color="white">$magnify_glass</VcIcon>
      </button>

      <button
        class="platform-mobile-top-bar__action-btn"
        data-qa="notifications-button"
        @click="$emit('notifications-click')"
      >
        <VcBadge :badgeText="notificationsBadge" :offset-y="4" :offset-x="4" size="sm">
          <VcIcon size="20" color="white">$notifications</VcIcon>
        </VcBadge>
      </button>

    </div>
  </div>
</template>

<script>
import AiChatStarIcon from '@/assets/images/ai/star.svg';

export default {
  name: 'PlatformMobileTopBar',
  components: { AiChatStarIcon },
  props: {
    primaryColor: {
      type: String,
      default: '',
    },
    profileDetails: {
      type: Object,
      default: () => ({ imagePath: '', colorId: 27, displayName: '' }),
    },
    notificationsBadge: {
      type: [String, Number],
      default: 0,
    },
    showAiChat: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.platform-mobile-top-bar {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--size-value4);
  height: var(--vc-top-bar-height);
  min-height: var(--vc-top-bar-height);

  &__profile {
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: var(--size-value3);
  }

  &__ai-icon {
    width: 20px;
    height: 20px;
    color: white;
  }

  &__action-btn {
    background: none;
    border: none;
    padding: 0;
    width: 32px;
    height: 32px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: relative;
    overflow: visible;
    transition: background-color 0.2s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
    }
  }
}
</style>
